import React from 'react';
import { industries } from '../mock';
import { Badge } from './ui/badge';

export const IndustriesSection = () => {
  return (
    <section id="industries" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Industries We Serve
          </h2>
          <p className="text-lg text-[#8D6E63] max-w-3xl mx-auto mb-6">
            Our trademark registration expertise spans across diverse industries and business sectors. No matter your field, we have the knowledge and experience to protect your brand effectively.
          </p>
          <p className="text-lg text-[#8D6E63] max-w-4xl mx-auto">
            With over 1,000 successful trademark registrations across virtually every industry, we understand the unique challenges and opportunities in different market sectors. From tech startups to traditional manufacturing, from professional services to consumer products, we've helped businesses of all types secure federal trademark protection. Each industry has specific considerations for trademark protection—descriptive terms that work in one field may be too generic in another, and we bring that nuanced understanding to every application.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 max-w-5xl mx-auto mb-8">
          {industries.map((industry, index) => (
            <Badge
              key={index}
              variant="secondary"
              className="px-6 py-3 text-base font-medium bg-[#EFEBE9] text-[#3E2723] border-2 border-[#D7CCC8] hover:bg-[#3E2723] hover:text-white hover:border-[#3E2723] transition-all duration-300 cursor-pointer"
            >
              {industry}
            </Badge>
          ))}
        </div>

        <div className="bg-[#EFEBE9] rounded-lg p-8 border-2 border-[#D7CCC8] max-w-4xl mx-auto">
          <h3 className="text-xl font-bold text-[#3E2723] mb-4 text-center">
            Industry-Specific Trademark Knowledge
          </h3>
          <p className="text-[#8D6E63] leading-relaxed mb-4">
            Every industry has unique trademark considerations. In technology, for example, functional names face higher scrutiny, while in fashion, design elements and trade dress are particularly important. Healthcare and pharmaceutical trademarks require careful attention to FDA regulations and safety concerns. Financial services marks must navigate regulatory compliance while remaining distinctive.
          </p>
          <p className="text-[#8D6E63] leading-relaxed">
            Our extensive experience across industries means we understand these nuances and can guide you toward stronger, more protectable marks. We know which terms the USPTO commonly refuses in your field, which competitors have established rights, and how to position your mark for maximum protection. This industry-specific knowledge significantly improves your chances of successful registration and long-term brand protection.
          </p>
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#8D6E63] text-lg mb-2">
            Don't see your industry listed? <span className="font-semibold text-[#3E2723]">We work with businesses of all types!</span>
          </p>
          <p className="text-[#8D6E63]">
            Contact us to discuss your specific needs and learn how we can protect your brand, regardless of your industry or business model.
          </p>
        </div>
      </div>
    </section>
  );
};
